export default "__VITE_ASSET__DO4emdq___"